import { baseFetch } from 'src/utils/baseFetch';

export const createStripePortalSession = async () => {
  const res = await baseFetch('/api/subscribe/create-customer-portal-session', {
    method: 'POST',
  });

  if (!res.ok) {
    throw new Error('Failed to create Stripe portal session');
  }

  const data = await res.json();

  window.location.href = data.url;
};
